import { render } from "./MdNavigationHeadline.vue?vue&type=template&id=207826b4&scoped=true&ts=true"
import script from "./MdNavigationHeadline.vue?vue&type=script&lang=ts"
export * from "./MdNavigationHeadline.vue?vue&type=script&lang=ts"

import "./MdNavigationHeadline.vue?vue&type=style&index=0&id=207826b4&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207826b4"]])

export default __exports__